import { TranslateConfigService, type Side } from '@/services/translation/translate-service.interface';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { useTranslationStates } from './use-translation-states';

export function useFetchTranslateConfig(option: { side: Side; } = { side: 'both' }) {
    const translateConfigService = injectService<TranslateConfigService>(TranslateConfigService);
    const { switchTranslateLanguage, setUserPreferredLangOptions } = useTranslationStates();

    async function fetchTranslateConfig() {
        const workspaceId = new URLSearchParams(window.location.search).get('workspace_id') || undefined;
        const data = await translateConfigService.getSelectedLanguage({ workspaceId });

        switchTranslateLanguage({
            side: option.side,
            lang: data.language,
            langType: data.langType,
        });

        setUserPreferredLangOptions({
            side: option.side,
            lang: data.language,
            langType: data.langType,
        });
    }

    return {
        fetchTranslateConfig,
    };
}
